export default "__VITE_ASSET__nVOj7PF0__"